<template>
  <div class="animated fadeIn compras-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card>
            <div slot="header">Crédito / Débito</div>
            <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Proveedor"
                  label-for="proveedor"
                  :label-cols="2"
                  horizontal>
                  <b-form-input 
                    id="proveedor"
                    :value="proveedorNombre"
                    readonly
                    type="text"/>
                </b-form-group>

                <div class="grupo-controles">
                  <b-form-group
                    label="Comp."
                    :label-cols="2"
                    horizontal>

                    <comprobante-tipo
                      label="tipo de comprobante"
                      selectId="comprobanteTipo"
                      :showLabel="false"
                      :nombre="comprobanteTipoNombre"
                      :valido="comprobanteTipoValido"
                      :lista="comprobantesTiposList"
                      :msjInvalido="comprobanteTipoInvalidoMsj"
                      @validate="validate"
                      @updated="comprobanteTipoActualizado">
                    </comprobante-tipo>

                    <formulario
                      label="formulario"
                      selectId="formulario"
                      :showLabel="false"
                      :nombre="formulario"
                      :valido="formularioValido"
                      :lista="formularios"
                      :msjInvalido="formularioInvalidoMsj"
                      :readOnly="formularioDisabled"
                      @validate="validate"
                      @updated="formularioActualizado">
                    </formulario>  
                  </b-form-group>
                </div>

                <div class="grupo-controles">
                  <b-form-group
                    label="Número"
                    label-for="numero"
                    :label-cols="2"
                    horizontal>
                    <b-form-input 
                      id="numeroPuntoVenta"
                      v-model.trim= "$v.numeroPuntoVenta.$model" 
                      :state="numeroPuntoVentaValido"
                      type="number"
                      min="0000" max="9999"
                      :readonly="numeroPuntoVentaDisabled"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-input 
                      id="numero"
                      v-model.trim= "$v.numero.$model" 
                      :state="numeroValido"
                      type="number"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-invalid-feedback id="numeroFeedback">
                      {{ numeroInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>
                </div>
              </b-col>

              <b-col xl="6">
                <b-form-group
                  label="Fecha Comp."
                  label-for="fechaComprobante"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="fechaComprobante" 
                    v-model= "fechaComprobante" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Fecha Venc."
                  label-for="fechaVencimiento"
                  :description="leyendaPlazo"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="fechaVencimiento" 
                    v-model= "fechaVencimiento" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Periodo"
                  label-for="periodo"
                  :label-cols="3"
                  horizontal>
                  <b-form-select 
                    v-model="periodoMesNombre" 
                    :options="meses" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-mes"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="null">Seleccione un mes</option>
                    </template>
                  </b-form-select>
                  <b-form-select 
                    v-model="periodoAnio" 
                    :options="anios" 
                    :state="periodoValido"
                    class="mb-3 select-fecha select-fecha-anio"
                    @blur.native="validate">
                    <template slot="first">
                      <option :value="0">Seleccione un año</option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="periodoFeedback">
                    {{ periodoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <b-card header="Ordenes del Proveedor" v-if="tieneOrdenesProveedores">
            <b-row>
              <b-col xl="12">
                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-ordenes-proveedores-credito" 
                    :busy="tableBusy"
                    :items="renglones" 
                    :fields="fields">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaComprobante)="data">
                    {{ data.item.fechaComprobante | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda }}
                  </template>
                  <template v-slot:cell(saldo)="data">
                    {{ data.item.saldo | moneda }}
                  </template>
                  <template v-slot:cell(importeFacturar)="data">
                      <input type="number"
                          v-model="data.item.importeFacturar"
                          step="0.01"
                          @keyup.enter.prevent="actualizarImporteCredito"
                          @change="actualizarImporteCredito"/>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Total"
                  label-for="montoNetoRenglones"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="montoNetoRenglones"
                    :value= "montoNetoRenglones | moneda" 
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col>
                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="cancelaSaldoRemitos"
                      v-model="cancelaSaldo"
                      :value="true"
                      :unchecked-value="false">
                      Cancela Saldos
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row> -->
          </b-card>

          <b-card header="Remitos del Proveedor" v-if="tieneRemitos">
            <b-row>
              <b-col xl="12">
                <b-table 
                    small 
                    responsive="sm"
                    class="registro-ordenes compra-remitos-credito" 
                    :busy="tableBusy"
                    :items="renglonesRemitos" 
                    :fields="fieldsRemitos">
                  <div slot="table-busy" class="text-center">
                    <b-spinner class="table-spinner" label="Spinning" />
                  </div>              
                  <template v-slot:cell(fechaComprobante)="data">
                    {{ data.item.fechaComprobante | fecha }}
                  </template>
                  <template v-slot:cell(importe)="data">
                    {{ data.item.importe | moneda }}
                  </template>
                  <template v-slot:cell(saldo)="data">
                    {{ data.item.saldo | moneda }}
                  </template>
                  <template v-slot:cell(importeFacturar)="data">
                      <input type="number"
                          v-model="data.item.importeFacturar"
                          step="0.01"
                          :disabled="data.item.presupuestoCerrado"
                          @keyup.enter.prevent="actualizarImporteCreditoRemitos"
                          @change="actualizarImporteCreditoRemitos"/>
                  </template>
                </b-table>
                <small><span>(*)</span> Corresponde a un presupuesto cerrado </small> 
                
                <br>
                <br>
                
                <b-form-group
                  :label-cols="labelCols"
                  description="El importe del crédito no estará disponible para su refacturación"
                  horizontal>
                  <b-form-checkbox 
                      id="cancelaSaldoRemitos"
                      v-model="cancelaSaldo"
                      :value="true"
                      :unchecked-value="false">
                      Cancela Saldos a Facturar
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col xl="6">
                <b-form-group
                  label="Total"
                  label-for="montoNetoRenglones"
                  :label-cols="3"
                  horizontal>
                  <b-form-input 
                    id="montoNetoRenglones"
                    :value= "montoNetoRenglones | moneda" 
                    type="text"
                    readonly>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row> -->
          </b-card>

          <app-totales
            ref="totales"
            :noValidar="noValidar">
          </app-totales>

          <b-card header="Cuentas">
            <app-compra-cuentas
              @agregarCuenta="agregarCuenta"
              @editarCuenta="editarCuenta"
              @borrarCuenta="borrarCuenta">
            </app-compra-cuentas>  
          </b-card>

          <b-form-group
            label-for="observaciones">
            <b-form-textarea
              id="observaciones"
              v-model= "$v.observaciones.$model" 
              rows="3"
              max-rows="6"
              :state="observacionesValidas"
              @blur.native="validate">
            </b-form-textarea>
            <b-form-invalid-feedback id="observacionesFeedback">
              {{ observacionesInvalidasMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="compraCuentaModal" 
        title="Información de la Cuenta"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM"
        lazy>
      <app-compra-cuenta
        :cuentas="planCuentas" 
        :cuentasList="planCuentasList"
        @updateCompraCuenta="updateCompraCuenta"
        @closeCompraCuenta="closeCompraCuentaModal">
      </app-compra-cuenta>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { required, decimal, minValue, maxValue, numeric, maxLength, minLength, between } from 'vuelidate/lib/validators';
import ABMButtons from '../shared/abmButtons.vue';
import ComprobanteTipo from '../shared/abmSelectSimple.vue';
import Formulario from '../shared/abmSelectSimple.vue';
import Totales from './Totales.vue'
import Mensaje from  '../shared/msjModal.vue';
import CompraCuenta from './CompraCuenta.vue'
import CompraCuentas from './CompraCuentas.vue'
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

export default {
  name: 'CompraCreditoDebito',
  components: {
    ComprobanteTipo,
    Formulario,
    appTotales: Totales,
    appABMButton: ABMButtons,
    appCompraCuenta: CompraCuenta,
    appCompraCuentas: CompraCuentas,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      periodoValido: null,
      periodoInvalidoMsj: '',
      comprobanteTipoValido: null,
      comprobanteTipoInvalidoMsj: '',
      formularioValido: null,
      formularioInvalidoMsj: '',
      numeroPuntoVentaValido: null,
      numeroValido: null,
      numeroInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      meses: [],
      anios: [],
      planCuentas: [],
      planCuentasList: [],

      fields: [
        {
            key: 'id',
            label: 'Nro.Orden',
            sortable: true
        },
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        {
            key: 'presupuesto',
        },
        { 
          key: 'importe', 
          label: 'Imp.Facturado',
          class: "text-right" 
        },
        { 
          key: 'saldo', 
          label: 'Saldo Acreditar',
          class: "text-right" 
        },
        { 
          key: 'importeFacturar', 
          label: 'Imp.Credito',
          class: "text-right" 
        },
      ],

      fieldsRemitos: [
        {
          key: 'fechaComprobante',
          label: 'Fecha'
        },
        { key: 'comprobante' },
        { key: 'destino' },
        { 
          key: 'importe', 
          label: 'Imp.Facturado',
          class: "text-right" 
        },
        { 
          key: 'saldo', 
          label: 'Saldo Acreditar',
          class: "text-right" 
        },
        { 
          key: 'importeFacturar', 
          label: 'Imp.Credito',
          class: "text-right" 
        },
      ],

      inicializando: Boolean(false),
      tableBusy: false,
      readOnly: Boolean(true),
    }
  },
  computed: {
    ...mapFields([
      'compraId',

      'proveedorNombre',
      'fechaComprobante',
      'fechaVencimiento',
      'plazoPago',
      'periodo',
      'periodoMesNombre',
      'periodoAnio',
      'comprobanteTipo',
      'comprobanteTipoNombre',
      'formulario',
      'formularios',
      'numeroPuntoVenta',
      'numero',
      'observaciones',
      'cancelaSaldo',
      'renglones',
      'montoNetoRenglones',
      'renglonesRemitos',
      'percepcionesProvinciales',

      'formularioDisabled',
      'numeroPuntoVentaDisabled', 
      'numeroDisabled',

      'comprobantesTipos',
      'comprobantesTiposList',

      'cuentaSelected',
    ]),
    tieneOrdenesProveedores() {
      if (this.renglones) {
        if (this.renglones.length != 0) {
          return true;
        }
      }
      return false;
    },
    tieneRemitos() {
      if (this.renglonesRemitos) {
        if (this.renglonesRemitos.length != 0) {
          return true;
        }
      }
      return false;
    },
    leyendaPlazo() {
      if (this.plazoPago) {
        if (this.plazoPago != 0) {
          return `Plazo de Pago: ${this.plazoPago.toString().trim()} días`;
        }
      }
      return '';
    },
  },
  created() {
    this.getDatosAdicionales();
    
    let compraId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        compraId = this.$route.params.id;
      }
    }

    let params = {
      compraId,
      creditoParcial: true
    }

    this.inicializando = true;
    this.showSpinner();
    this.$store.dispatch('compra/inicializarCreditoDebito', params)
      .then(() => this.inicializando = false)
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.meses = this.getMeses();
      this.anios = this.getAniosPeriodo();

      this.planCuentas = [];
      this.planCuentasList = [];
      this.$store.dispatch('cuentas/getList')
        .then(() => {
          this.planCuentas = this.$store.getters['cuentas/list']
          this.planCuentasList = this.$store.getters['cuentas/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de cuentas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numeroPuntoVenta' || validarTodos) {
        if (this.$v.numeroPuntoVenta.$error) {
          this.numeroPuntoVentaValido = false;
        } else {
          this.numeroPuntoVentaValido = null;
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
        } else {
          this.numeroValido = null;
        }
      }

      if (!this.numeroValido || !this.numeroPuntoVentaValido) {
        this.numeroInvalidoMsj = 'Verifique la información del número y del punto de venta.';
      } else {
        this.numeroInvalidoMsj = '';
      }

      if (campo == "observaciones" || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones sólo pueden contener hasta 500 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

      if (validarTodos) {
        this.$refs.totales.displayErrores();
      }

    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let save = Boolean(true);

      // let comprobanteTipo;
      // if (this.comprobanteTipoNombre) {
      //   comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
      // }
      // this.$store.dispatch('compra/setComprobanteTipo', comprobanteTipo);

      let comprobanteTipoError = true;
      if (this.comprobanteTipo) {
        if (this.comprobanteTipo.id) {
          if (this.comprobanteTipo.id != 0) {
            comprobanteTipoError = false;
          }
        }
      }
      if (comprobanteTipoError) {
        save = Boolean(false);
        this.comprobanteTipoValido = false;
        this.comprobanteTipoInvalidoMsj = "Debe seleccionar el tipo de comprobante correspondiente.";
      }

      if (this.formulario.trim() == '') {
        save = Boolean(false);
        this.formularioValido = false;
        this.formularioInvalidoMsj = "Debe seleccionar el formulario correspondiente.";
      }

      let mes = this.getMesNumero(this.periodoMesNombre);
      let anio = parseInt(this.periodoAnio);

      if (!this.isValidDate(1, mes, anio))
      {
        this.periodoValido = false;
        this.periodoInvalidoMsj = 'Debe seleccionar el período del comprobante.';
        save = Boolean(false);
      } else {
        this.periodoValido = null;
        this.periodoInvalidoMsj = '';
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        //console.log('Errores')
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('compra/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.go(-1);
    },

    comprobanteTipoActualizado(comprobanteTipoNombre) {
      if (!this.inicializando) {
        this.comprobanteTipoNombre = comprobanteTipoNombre;

        let comprobanteTipo;
        if (this.comprobanteTipoNombre) {
          comprobanteTipo = this.getSelected(this.comprobantesTipos, this.comprobanteTipoNombre);
        }
        
        this.$store.dispatch('compra/setComprobanteTipo', comprobanteTipo);
        this.$store.dispatch('compra/calcularMontos')

        this.comprobanteTipoValido = null;
        this.comprobanteTipoInvalidoMsj = '';
      }
    },    
    formularioActualizado(formulario) {
      if (!this.inicializando) {
        this.formulario = formulario;

        this.formularioValido = null;
        this.formularioInvalidoMsj = '';
      }
    },
    actualizarImporteCredito() {
      this.tableBusy = true;
      this.$store.dispatch('compra/calcularTotalOrdenes')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },
    actualizarImporteCreditoRemitos() {
      this.tableBusy = true;
      this.$store.dispatch('compra/calcularTotalRemitos')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.tableBusy = false);
    },

    agregarCuenta(item) {
      this.cuentaSelected = null
      this.$refs.compraCuentaModal.show()
    },
    editarCuenta(item) {
      this.cuentaSelected = item
      this.$refs.compraCuentaModal.show()
    },
    borrarCuenta(item) {
      this.cuentaSelected = item
      this.$store.dispatch('compra/deleteCuenta')
    },

    updateCompraCuenta(compraCuenta) {
      this.$store.dispatch('compra/setCuenta', compraCuenta)
      this.$refs.compraCuentaModal.hide()
    },
    closeCompraCuentaModal() {
      this.$refs.compraCuentaModal.hide()
    },
  },
  validations: {
    numeroPuntoVenta: {
      required,
      numeric,
      minValue: minValue(1),
      maxValue: maxValue(9999)
    },
    numero: {
      required,
      numeric,
      minValue: minValue(1),
      maxValue: maxValue(99999999)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
    'fechaComprobante' : function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.$store.dispatch('compra/calcularFechaVencimiento');
      }
    },
    'formulario' : function(newVal, oldVal) {
      this.$store.dispatch('compra/calcularMontosTotal')
    },
  },
}
</script>

<style>
.compra-ordenes-proveedores-credito table td[aria-colindex="1"] {
  width: 10%;
}
.compra-ordenes-proveedores-credito table td[aria-colindex="2"] {
  width: 10%;
}
.compra-ordenes-proveedores-credito table td[aria-colindex="3"] {
  width: 50%;
}
.compra-ordenes-proveedores-credito table td[aria-colindex="4"],
.compra-ordenes-proveedores-credito table td[aria-colindex="5"],
.compra-ordenes-proveedores-credito table td[aria-colindex="6"] {
  width: 10%;
}

.compra-remitos-credito table td[aria-colindex="1"] {
  width: 10%;
}
.compra-remitos-credito table td[aria-colindex="2"] {
  width: 10%;
}
.compra-remitos-credito table td[aria-colindex="3"] {
  width: 50%;
}
.compra-remitos-credito table td[aria-colindex="4"],
.compra-remitos-credito table td[aria-colindex="5"],
.compra-remitos-credito table td[aria-colindex="6"] {
  width: 10%;
}
</style>
